<template>
  <div name="outcomeedit" class="inner">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        <router-link to="outcomes"> Outcomes </router-link>
        <i class="carret fas fa-caret-right"></i> {{ barTitle }}
      </template>

      <template v-slot:listitems>
        <li
          v-if="!newAddition && 1 == 2"
          @click="deletion"
          v-tooltip="{
            content: 'Delete Outcome',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          title="Delete Pupil"
          class="action-list-item inline-block hover:opacity-100"
        >
          <i class="icon fas fa-trash-alt" title="Delete Pupil"></i>
        </li>

        <li
          v-if="!newAddition && 1 == 2"
          class="inline-block mx-4 text-2xl text-gray-400"
        >
          |
        </li>

        <li class="inline-block">
          <button
            @click="submitForm()"
            type="button"
            class="publish-button hover:opacity-75"
          >
            Publish Changes
          </button>
        </li>
      </template>
    </innertopbar>

    <transition name="fade">
      <div class="loading" v-show="isSaving">
        <span class="fa fa-spinner fa-spin"></span> Saving
      </div>
    </transition>

    <form v-on:submit.prevent="submitOutcome" id="outcomeForm" ref="form">
      <div class="w-full mx-auto grid grid grid-flow-col grid-cols-2 gap-20">
        <div class="mt-6 ml-10 p-8 bg-white rounded-lg mb-10">
          <div class="w-95p mx-auto">
            <h2 class="w-full text-xl mb-8 -mx-3 pt-4 font-bold text-gray-700">
              Outcome Information
            </h2>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Outcome Title
                </label>
                <textarea
                  v-model="title"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title"> Criteria</label>

                <div class="flex flex-wrap">
                  <div
                    v-for="item in criteriaDropdown"
                    :key="item.key"
                    @click="criteriaSelect(item)"
                    class="mr-3 mb-2 rounded p-2 px-5 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
                    v-bind:class="
                      selectedCriteria.key == item.key
                        ? 'bg-action-blue bg-opacity-75 text-white'
                        : 'bg-gray-200 text-gray-600'
                    "
                  >
                    <i
                      class="far pr-1"
                      v-bind:class="
                        selectedCriteria.key == item.key
                          ? 'fa-check-circle'
                          : 'fa-dot-circle'
                      "
                    ></i>
                    {{ item.value }}
                  </div>
                </div>
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title"> Year Groups</label>

                <div class="flex flex-wrap">
                  <div
                    v-for="item in years"
                    :key="item.value"
                    @click="selectYear(item)"
                    class="mr-3 mb-2 rounded p-2 px-5 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
                    v-bind:class="
                      inSelectedYears(item)
                        ? 'bg-action-blue bg-opacity-75 text-white'
                        : 'bg-gray-200 text-gray-600'
                    "
                  >
                    <i
                      class="far pr-1"
                      v-bind:class="
                        inSelectedYears(item) ? 'fa-check-square' : 'fa-square'
                      "
                    ></i>
                    {{ item.name }}
                  </div>
                </div>
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Visible On System
                </label>
                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
                  v-bind:class="[
                    true === isActive
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isActive = true"
                >
                  Active
                </button>

                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-times"
                  v-bind:class="[
                    false === isActive
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isActive = false"
                >
                  Off
                </button>
                <p class="text-red-300 text-xs mt-1 italic">
                  Please fill out this field.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="p-6 px-8 bg-white mb-3">
          <div class="w-95p mx-auto">
            <savenotice
              :title="'Pupil'"
              ref="saveNotice"
              class="right"
            ></savenotice>

            <h2 class="w-full text-xl mb-4 -mx-3 pt-4 font-bold text-gray-700">
              Outcome Visibility
            </h2>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Outcome Assignment
                </label>
                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue disabled:opacity-50 disabled:cursor-not-allowed"
                  v-bind:class="[
                    !unitOnly
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="unitOnly = false"
                  :disabled="canSelectUnitsDisabled"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      !unitOnly ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  Available to all courses
                </button>
                
                <button
                  type="button"
                  class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue disabled:opacity-50 disabled:cursor-not-allowed"
                  v-bind:class="[
                    unitOnly
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="unitOnly = true"
                  :disabled="canSelectUnitsDisabled"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      unitOnly ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  Course Based
                </button>
              </div>
            </div>

            <div
              class="mt-0 w-full  mb-10"
              v-if="unitOnly"
            >

              <div class="flex flex-wrap  -mx-3 mb-8">
                <div class="w-full">
                <label class="form-label" for="grid-title">
                  Unit selection
                </label>
               
                  <outcomecourse
                    :subject="subject"
                    :years="years"
                    :outcomeUnitsSelected="unitsSelected"
                    :selectedYears="selectedYears"
                    ref="outcomecourse"
                    @selectedUnitsUpdated="updateSelectedUnits"
                    v-if="outcomeObject != undefined"
                  ></outcomecourse>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
const savenotice = () => import("@/components/SaveNotice.vue");
const innertopbar = () => import("@/components/InnerTopBar.vue");

import outcomecourse from "@/components/customunit/OutcomeCourses.vue";
import { OutcomeService } from "@/services/outcome.service";

export default {
  name: "outcomeedit",
  props: {
    newAddition: Boolean,
    outcome: Object,
    years: Array,
    order: Number,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      settings: "settings",
      subjects: "subjects",

    }),
    subject() {
      // if (this.outcomeObject.subject_id != undefined) {
      //   return this.outcomeObject.subject_id 
      // }
      return this.subjects.defaultSubject 
    },
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
    isDisabled() {
      if (this.title.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    canSelectUnitsDisabled() {
      return this.selectedYears.length <= 0;
    },
    barTitle() {
      if (this.newAddition) {
        return "Add new outcome";
      } else {
        return this.title.length > 0
          ? this.title.substring(0, 40) + "..."
          : this.title;
      }
    },
    allowCourseAssignment() {
      if (this.newAddition || this.unitOnly == "true") {
        return false;
      } else {
        return true;
      }
    },
    criteriaDropdown() {
      if (this.settings.assessmentCriteriaList.length > 0) {
        return this.settings.assessmentCriteriaList.filter(
          (c) => c.used === true
        );
      }
    },
    orderedUnits() {
      var vm = this;
      var type = vm.selectedUnitType.id;
      var year = vm.selectedYear.id;

      let slicedUnits = vm.units.filter((unit) => {
        return this.selectedYears.includes(unit.year_id);
      });

      if (type == 0 && year == 0) {
        return _.orderBy(slicedUnits, ["year_id", "category_id", "name"]);
      } else {
        var filtered = slicedUnits.filter(function (unit) {
          let filtered = true;

          if (type > 0) {
            filtered = unit.type_id === type;
          }

          if (filtered) {
            if (year > 0) {
              filtered = unit.year_id === year;
            }
          }
          return filtered;
        });

        return _.orderBy(filtered, ["year_id", "category_id", "name"]);
      }
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      errorNotice: "",
      unitTypes: [
        { id: 0, name: "All Unit Types" },
        { id: 1, name: "PE Passport Units" },
        { id: 3, name: "Custom Units" },
      ],
      selectedCriteria: {},
      units: [],
      selectedUnitType: {},
      selectedYears: [],
      title: "",
      isActive: true,
      unitOnly: false,
      unitsSelected: [],
      isSaving: false,
      outcomeObject: this.outcome
    };
  },
  created() {
    this.selectedCriteria = this.settings.assessmentCriteriaList[0];

    if (this.newAddition == false) {
      if (this.outcomeObject.identifier == undefined) {
        this.closeWindow();
        return;
      } else {
        (this.title =
          this.outcomeObject.title === undefined
            ? ""
            : this.outcomeObject.title),
          (this.unitOnly =
            this.outcomeObject.unit_only === undefined ||
            this.outcomeObject.unit_only === 1
              ? true
              : false),
          (this.isActive =
            this.outcomeObject.active === undefined ||
            this.outcomeObject.active === 1
              ? true
              : false),
          (this.outcomeObject.display_order =
            this.outcomeObject.display_order === undefined
              ? this.order
              : this.outcomeObject.display_order);
        this.selectedYears =
          this.outcomeObject.years == null
            ? []
            : this.outcomeObject.years.map((y) => {
                return y.id;
              });

        this.unitsSelected =
          this.outcomeObject.courses == undefined
            ? []
            : this.outcomeObject.courses.map((c) => c.id);

        this.setCriteria();
      }
    }
  },
  methods: {
    submitForm() {
      this.isSaving = true;

      if (this.$refs.form.requestSubmit === undefined) {
        this.submitOutcome();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    alertDisplay() {
      this.$swal({
        title: "Empty Fields",
        text: "You have empty fields that are required",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
    },
    updateSelectedUnits(values) {
      this.unitsSelected = values;
    },
    submitOutcome() {
      if (
        this.title == "" ||
        this.selectedYears.length == 0 ||
        this.selectedCriteria.value == ""
      ) {
        this.alertDisplay();
        this.isSaving = false;
      } else {
        this.processOutcome();
      }
    },
    processOutcome() {
      let outcomeTitle = this.title.trim();
      let criteria =
        this.selectedCriteria.value.length > 0
          ? this.selectedCriteria.key
          : "objectives";

      let years = this.selectedYears.map((y) => {
        return { id: y };
      });
      let courses = this.unitsSelected.map((u) => {
        return { course_id: u };
      });

      let typeId = this.isContentAdmin ? 1 : this.currentUser.typeID;
      
      this.outcomeObject.title = outcomeTitle
      this.outcomeObject.criteria = criteria
      this.outcomeObject.unit_only =  this.unitOnly === true ? 1 : 0
      this.outcomeObject.type_id = typeId
      this.outcomeObject.active = this.isActive === true ? 1 : 0,
      this.outcomeObject.years = years
      this.outcomeObject.courses = courses

      // add new or update
      if (this.outcomeObject.identifier === undefined) {

        OutcomeService.add(this.outcomeObject)
          .then((response) => {
            this.outcomeObject.identifier = response.data.identifier;
            this.completion(outcomeTitle + " created");
          })
          .catch((err) => {
            this.completion(outcomeTitle + " error");
            console.log("Outcome add error " + err);
          });
      } else {
        OutcomeService.update(this.outcomeObject, this.outcomeObject.identifier)
          .then((response) => this.completion(outcomeTitle + " updated"))
          .catch((err) => {
            this.completion(outcomeTitle + " error");
            console.log("Outcome update error " + err);
          });
      }
    },
    completion(msg) {
      this.isSaving = false;
      this.$router.push({
        path: "/my-content/custom-outcomes",
        params: { msg: msg },
      });
    },
    closeWindow() {
      this.$router.push({ path: "/my-content/custom-outcomes" });
      window.scrollTo(0, 0);
    },
    criteriaSelect(val) {
      this.criteriaSelect = val;
    },
    setCriteria() {
      let ct = this.settings.assessmentCriteriaList
        .filter((criteria) => {
          return this.outcomeObject.criteria === criteria.key;
        })
        .shift();
      if (ct != undefined) {
        this.selectedCriteria = ct;
      }
    },
    setUnitOnly(val) {
      this.unitOnly = val;
    },
    selectYear(year) {
      if (this.selectedYears.includes(year.id)) {
        this.selectedYears.splice(this.selectedYears.indexOf(year.id), 1);
      } else {
        this.selectedYears.push(year.id);
      }

      if (this.selectedYears.length === 0) {
        this.unitOnly = false;
      }
    },
    inSelectedYears(year) {
      return this.selectedYears.includes(year.id) ? "active" : "";
    },
    unitTypeSelect(unit) {
      this.selectedUnitType = unit;
    },
    yearSelect(year) {
      this.selectedYear = year;
    },
    criteriaSelect(criteria) {
      this.selectedCriteria = criteria;
    },
    deletion() {},
  },
  components: {
    savenotice,
    outcomecourse,
    innertopbar,
  },
};
</script>


<style scoped>
.off {
  margin-right: 11px;
}

.form-group span {
  font-weight: 400 !important;
}
.form-group.buttons a {
  margin-bottom: 19px;
}

.text-red .icon {
  color: #f56a6a;
}

.tab {
  width: 100% !important;
}

.tab button {
  min-width: 50%;
  width: 50% !important;
}
</style>
